import script from "./notificacaoes_agendamentos.vue?vue&type=script&setup=true&lang=js"
export * from "./notificacaoes_agendamentos.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__